/**
 * Arabic-aware product search for the home and fast-delivery grids.
 * "بوكس الشواء" must match "بوكس شواء لحم كبير": the definite article, hamza/alef
 * forms, taa marbuta and word order must not block a match.
 */

const DIACRITICS = /[\u0610-\u061A\u064B-\u065F\u0670\u0640]/g;
const ARABIC_INDIC_DIGITS = /[\u0660-\u0669]/g;
const NON_WORD = /[^\p{L}\p{N}]+/gu;
const DEFINITE_ARTICLE = /^ال(?=.{2,})/;

function normalizeWord(word) {
    return word.replace(DEFINITE_ARTICLE, "");
}

export function normalizeArabicText(value) {
    if (value === null || value === undefined || value === false) {
        return "";
    }
    return String(value)
        .toLowerCase()
        .replace(DIACRITICS, "")
        .replace(ARABIC_INDIC_DIGITS, (d) => String(d.charCodeAt(0) - 0x0660))
        .replace(/[أإآٱ]/g, "ا")
        .replace(/ى/g, "ي")
        .replace(/ة/g, "ه")
        .replace(/ؤ/g, "و")
        .replace(/ئ/g, "ي")
        .replace(/ء/g, "")
        .replace(NON_WORD, " ")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(normalizeWord)
        .join(" ");
}

export function searchTokens(query) {
    const normalized = normalizeArabicText(query);
    return normalized ? normalized.split(" ") : [];
}

function textMatches(text, tokens) {
    const haystack = normalizeArabicText(text);
    return tokens.every((token) => haystack.includes(token));
}

export function productMatchesSearch(product, query) {
    const tokens = searchTokens(query);
    if (!tokens.length) {
        return true;
    }
    if (textMatches(product?.name, tokens)) {
        return true;
    }
    return (product?.variants || []).some((variant) => textMatches(variant?.name, tokens));
}

/** Keeps categories that still have products after filtering by `query`. */
export function filterCategoriesBySearch(categories, query) {
    const list = categories || [];
    if (!searchTokens(query).length) {
        return list;
    }
    const result = [];
    for (const category of list) {
        const products = (category?.categ_ids || []).filter((product) => productMatchesSearch(product, query));
        if (products.length > 0) {
            result.push({ ...category, categ_ids: products });
        }
    }
    return result;
}

/** One main category row by Odoo id (for `/category/:id`). */
export function filterCategoriesById(categories, rawId) {
    const list = categories || [];
    if (rawId === null || rawId === undefined || rawId === "") {
        return list;
    }
    const want = Number(rawId);
    return list.filter(
        (cat) =>
            (!Number.isNaN(want) && Number(cat?.id) === want) ||
            String(cat?.id) === String(rawId)
    );
}
